import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const resetData = (state) => {
  state.tableQrList = [];
};

const tableQrListSuccess = (state, tableQrList) => {
  state.tableQrList = tableQrList;
};

const createTableQrSuccess = (state, payload) => {
  state.tableQrList.push(payload);
};

const editTableQrListSuccess = (state, payload) => {
  const foundIndex = state.tableQrList.findIndex((tableQr) => tableQr.guid === payload.guid);
  state.tableQrList[foundIndex] = payload;
};

const removeTableQrListSuccess = (state, payload) => {
  state.tableQrList = state.tableQrList.filter(((tableQr) => tableQr.guid !== payload.guid));
};

export const mutations = {
  [MutationTypes.TABLE_QR_LIST_SUCCESS]: tableQrListSuccess,
  [MutationTypes.CREATE_TABLE_QR_SUCCESS]: createTableQrSuccess,
  [MutationTypes.EDIT_TABLE_QR_SUCCESS]: editTableQrListSuccess,
  [MutationTypes.DELETE_TABLE_QR_SUCCESS]: removeTableQrListSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
